import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper, Button } from '@mui/material';
import VirtualizedOutletList from './VirtualizedOutletList';
import OutletSearch from './OutletSearch';

const OutletListContainer = ({
  filteredOutlets,
  totalCount,
  allOutlets,
  hasMore,
  handleLoadMore,
  onTypeChange,
  searchQuery,
  setSearchQuery,
  allOutletNames,
}) => {
  return (
    <Paper sx={{ p: 2, mt: { xs: 8, md: 2 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">
          {searchQuery
            ? `Search Results: ${filteredOutlets.length} outlets found`
            : `All Outlets (${filteredOutlets.length} shown of ${totalCount} total)`}
        </Typography>
      </Box>

      <OutletSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} allOutletNames={allOutletNames} />

      <Paper variant="outlined" sx={{ overflow: 'auto' }}>
        {filteredOutlets.length > 0 ? (
          <VirtualizedOutletList outlets={filteredOutlets} onTypeChange={onTypeChange} searchQuery={searchQuery} />
        ) : (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {searchQuery ? 'No outlets found matching your search.' : 'No outlets found.'}
            </Typography>
          </Box>
        )}
      </Paper>

      {filteredOutlets.length > 0 && hasMore && !searchQuery && (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Button variant="outlined" onClick={handleLoadMore} sx={{ mt: 2 }}>
            Load More ({totalCount - allOutlets.length} remaining)
          </Button>
        </Box>
      )}
    </Paper>
  );
};

OutletListContainer.propTypes = {
  filteredOutlets: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  allOutlets: PropTypes.array.isRequired,
  hasMore: PropTypes.bool.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  allOutletNames: PropTypes.array.isRequired,
};

export default OutletListContainer;
